import gql from 'graphql-tag'

export const GET_CLASS_ACTIVITIES = gql`
  query ($courseId: Int!, $limit: Int, $page: Int) {
    academyClassActivities(courseId: $courseId, limit: $limit, page: $page) {
      meta {
        total
        limit
        page
      }
      data {
        date
        state
        userId
        startDate
        endDate
        completedPercent
        completedOn
        completedOnSchedule
        updatedAt
      }
    }
  }
`
